import '../index.css';

interface LumpSumInputProps {
  id: string;
  label: string;
  value?: number;
  helpText?: string;
  disabled?: boolean;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const LumpSumInput = ({
  id,
  label,
  value,
  helpText,
  disabled,
  onBlur,
}: LumpSumInputProps) => {

  const displayValue = value ? Number.parseFloat(String(value)).toFixed(2) : '0.00';
  
  return (
    <div className="row">
      <div className="col-md-5">
        <ps-numeric-field
          data-testid={id}
          input-id={id}
          label={label}
          value={displayValue}
          icon-left
          icon="currency-dollar"
          extraClass="disable-increment"
          onBlur={onBlur}
          help-text={helpText}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
